import {
    CvtConcern,
    type CvtConcernOption,
    type CvtPrimaryConcernsModalContent,
} from './cvt-primary-concerns-modal.types';

/**
 * Maps the selected concerns to the content the modal shows next. Only a drivability concern needs the CVT application.
 */
export function toCvtPrimaryConcernsModalContent(
    selectedConcernOptions: CvtConcernOption[]
): CvtPrimaryConcernsModalContent {
    if (selectedConcernOptions.length === 0) {
        return 'selectConcerns';
    }

    if (selectedConcernOptions.some((option) => option.value === CvtConcern.Drivability)) {
        return 'runCvtDiagnostic';
    }

    return 'cvtDiagnosticNotRequired';
}
